/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Kn_Need_AddressInputs */

const cs_property_registry_kn_need_address = /** @type {(inputs: Property_Registry_Kn_Need_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KN umí budovu jen podle adresního místa (RÚIAN úroveň 1). U adresy vyberte konkrétní číslo popisné / adresní místo, ne jen ulici nebo obec.`)
};

const en_property_registry_kn_need_address = /** @type {(inputs: Property_Registry_Kn_Need_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KN can resolve a building only from an address point (RÚIAN level 1). Pick a concrete house number / adresní místo, not just a street or municipality.`)
};

/**
* | output |
* | --- |
* | "KN can resolve a building only from an address point (RÚIAN level 1). Pick a concrete house number / adresní místo, not just a street or municipality." |
*
* @param {Property_Registry_Kn_Need_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_kn_need_address = /** @type {((inputs?: Property_Registry_Kn_Need_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Kn_Need_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_kn_need_address(inputs)
	return cs_property_registry_kn_need_address(inputs)
});